<template>
  <div class="col-12 u-marg-t-sm">
    <!-- <span class="u-bold u-marg-r-xs">{{ $t('Availability') }} :</span> -->
    <span
      v-if="status.availability_color && status.availability_color.length > 0"
      :style="`color: ${status.availability_color}`"
      :class="['c-status', statusClass]">
        {{ statusText }}
    </span>
    <span
      v-else
      :class="['c-status', statusClass]">
        {{ statusText }}
    </span>
    <!-- <span class="c-product-offer__separator"></span> -->
    <span v-if="status.availability && statusClass !== 'c-status--warn2 yellow-text'"
      class="t-text u-grey-text ml-2 delivery ">
      {{ $t('Delivery in 3-4 working days') }}
    </span>
    <span v-if="!status.availability || statusClass === 'c-status--warn2 yellow-text'" class="t-text u-grey-text ml-2 delivery">
      <u class="idz_btn_fix">
        <a href="#" id="iadvize-btn-device-page-offline">{{ $t('Contact us iadvize') }}</a>
        <a href="#" id="iadvize-btn-device-page-online" style="display: none">{{ $t('Chat with us') }}</a>
        <a href="#" id="iadvize-btn-device-page-busy" style="display: none">{{ $t('Chat with us') }}</a>
      </u> {{ $t('to check in-shop availability') }}</span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      status: {
        type: Object,
        default: () => {}
      },
    },
    computed: {
      ...mapGetters({
        $t: 'GET_TRAD'
      }),
      statusText () {
        let statusText = ''
        switch (this.status.availability) {
          case true:
            statusText = this.$t('Available')
          break
          case false:
            statusText = this.$t('Unavailable online')
          break
          default:
            statusText = this.status.availability
          break
        }

        return statusText

      },
      statusClass () {
        let className = ''
        switch (this.status.availability) {
          case true:
            className = 'c-status--ok2 green-text'
          break
          case false:
            className = 'c-status--ko2 red-text'
          break
          default:
            className = 'c-status--warn2 yellow-text'
          break
        }
        return className
      }
    }
  }
</script>
